import { UnimpersonateUrlHandler } from '../../src/zportiAdmin/components/UnimpersonateUrlHandler/UnimpersonateUrlHandler'

export default function UnimpersonateRoute() {
  return <UnimpersonateUrlHandler />
}
